import React, { useCallback, useState } from 'react';
import { View } from 'react-native';
import i18n from 'utils/i18n';
import Button from 'design-system/Button';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import { rem } from 'design-system/values';
import createStyleSheets from 'utils/createStyleSheets';
import RowAchAccount from './RowAchAccount';
const AchAccountConfirmModalContent = ({ account, ctaLabel = 'Save', onConfirm, }) => {
    const styles = useStyles(styleSet);
    const [isFetching, setIsFetching] = useState(false);
    const handlePress = useCallback(async () => {
        setIsFetching(true);
        try {
            await onConfirm();
        }
        finally {
            setIsFetching(false);
        }
    }, [onConfirm]);
    return (<View style={styles.container}>
      <Spacer h={16}/>
      <Text TextThin-16 Secondary centered>
        By saving this, I {i18n.t('authorise')} Emma to electronically debit my
        account
      </Text>
      <Spacer h={24}/>
      <RowAchAccount account={account}/>
      <Spacer h={24}/>
      <Button brand title={ctaLabel} onPress={handlePress} isFetching={isFetching} style={styles.button}/>
    </View>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        paddingHorizontal: rem(16),
    },
    button: {
        marginHorizontal: rem(0),
    },
}));
const showAchAccountConfirmModal = (props) => {
    Modal.show(<AchAccountConfirmModalContent {...props}/>, {
        title: 'Confirm payment account',
        containerStyle: { paddingHorizontal: 0 },
        onBackdropPress: props.onDismissed,
        onSwipeComplete: props.onDismissed,
        onAndroidBackButtonPress: props.onDismissed,
    });
};
export default showAchAccountConfirmModal;
